import React from 'react';

function About() {
  return (
    <div>
      <section id="about" class="about" style={{ scrollMarginTop: '20px' }}>
        <div class="container" data-aos="fade-up">
          <br />
          <div class="section-title">
            <h2>About Us</h2>
          </div>

          <div class="row content">
            <div class="col-lg-6">
              <p>
                Looking for cost-effective web hosting? Softskart is your
                one-stop solution! We provide secure, high-speed hosting plans
                tailored to businesses, bloggers, and developers—ensuring
                maximum uptime and performance.
              </p>
              <ul class="fw-bold">
                <li>
                  <i class="ri-check-double-line text-dark"></i> High Speed –
                  99.9% uptime, LiteSpeed, NVMe SSD
                </li>
                <li>
                  <i class="ri-check-double-line text-dark"></i> Secure & Easy –
                  Anti-DDoS, Free SSL, cPanel, Softaculous
                </li>
                <li>
                  <i class="ri-check-double-line text-dark"></i> Reliable
                  Backups – JetBackup for data safety
                </li>
              </ul>
            </div>
            <div class="col-lg-6 pt-4 pt-lg-0">
              <p>
                Additionally, we offer 100% original software license keys for
                top-rated applications, including Windows, Microsoft Office,
                antivirus programs, and more—all at unbeatable prices. Say
                goodbye to expensive subscriptions and unreliable sources. With
                Softskart, you get affordability, authenticity, and excellent
                customer support.
              </p>
              <p>
                Start your journey with us today and experience hassle-free
                hosting and software solutions!
              </p>
              {/* <a href class="btn-learn-more">
                  Learn More
                </a> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
